import React, { useState } from "react";
import Desktop from "./os/Desktop";
import BootScreen from "./windows/BootScreen";

const BOOT_KEY = "jakob-os-booted";

function App() {
  const [booted, setBooted] = useState(() => sessionStorage.getItem(BOOT_KEY) === "1");

  const handleBootDone = () => {
    sessionStorage.setItem(BOOT_KEY, "1");
    setBooted(true);
  };

  return (
    <div className="h-screen w-screen overflow-hidden font-ui">
      {!booted && <BootScreen onDone={handleBootDone} />}
      {booted && <Desktop />}
    </div>
  );
}

export default App;
